module.exports = __webpack_public_path__ + "f4fd49dc27da3761329c010a10b92fef.pdf";